import React from "react"
import { Link, graphql } from "gatsby"
import { css } from "@emotion/react"
import { rhythm } from "../utils/typography"
import Layout from "../components/layout"

export default function Home({ data }) {
  return (
    <Layout>
      <div style={{ margin: `2rem auto`, maxWidth: `1024px`, padding: `0 1rem` }}>
        {data.allMarkdownRemark.edges.map(({ node }) => (
          <div key={node.id}>
            
            <h3 css={css`margin-bottom: ${rhythm(1 / 4)};`}> <Link to={node.fields.slug}>{node.frontmatter.title}</Link>{" "}
              <span css={css`color: #bbb;`}> — {node.frontmatter.date} </span>
            </h3>
            <p>{node.excerpt}</p>
            {node.frontmatter.tags.map((tag) => (
               <Link to={`/tags/${tag}`}>
                 <span css={css`color: #bbb;`}> #{tag} </span>
               </Link>
            ))}
          </div>
        ))}
      </div>
    </Layout>
  )
}

export const query = graphql`
  query {
    allMarkdownRemark {
      edges {
        node {
          id
          frontmatter {
            title
            date(formatString: "DD MMMM, YYYY")
            tags
          }
          excerpt
          fields {
            slug
          }
        }
      }
    }
  }
`